import React from "react";
import "./sidebar.css";
import { Accordion, Card } from "react-bootstrap";
import { Link } from "react-router-dom";

const CloudSidebar = (props) => {


  function DashboardPropertyToggle(item, index, setpropertyToggle) {
    console.log(props.sidebarClassesProperty[index], "props.sidebarClassesProperty[index]", props.sidebarClassesProperty)
    let propertyToggleData = localStorage.getItem("propertyToggleData") ? JSON.parse(localStorage.getItem("propertyToggleData")) : {};
    if ((props.sidebarClassesProperty[index] == 1) && propertyToggleData[`${item[index]?._id}`] && propertyToggleData[`${item[index]?._id}`] === true) {
      // if (propertyToggleData[`${item[index]?._id}`] && propertyToggleData[`${item[index]?._id}`] === true) {
      propertyToggleData[`${item[index]?._id}`] = false;
      console.log(index, "index1");
      // }

    } else {
      if (props.sidebarClassesProperty[index] == 0) {

        propertyToggleData[`${item[index]?._id}`] = true;
        console.log(index, "index");
      }

    };

    localStorage.setItem("propertyToggleData", JSON.stringify(propertyToggleData));
    props.setpropertyToggles(propertyToggleData);
  }

  const getActiveKeyProperty = () => {
    for (let i = 0; i < props.sidebarClassesProperty.length; i++) {
      // console.log(props.sidebarClassesProperty, "asdfghjkl")
      if (props.sidebarClassesProperty[i] === "1") {
        return i.toString();
      }
    }
    return "";
  };
  const getActiveKeyChannel = () => {
    for (let i = 0; i < props.sidebarClassesChannel.length; i++) {
      console.log(props.sidebarClassesChannel, "`123456789`")
      if (props.sidebarClassesChannel[i] === "1") {
        return i.toString();
      }
    }
    return "";
  };

  const togglePropertyCard = (event, index) => {
    let x = [...props.sidebarClassesProperty];
    let y = [...props.propertyButtons];
    for (let i = 0; i < x.length; i++) {
      if (i !== index) {
        y[i] = "fa-plus-circle";
        x[i] = "0";
      }
    }
    y[index] = x[index] === "1" ? "fa-plus-circle" : "fa-minus-circle";
    x[index] = x[index] === "1" ? "0" : "1";
    props.setsidebarClassesProperty(x);
    props.setpropertyButtons(y);
    localStorage.setItem("propertyClasses", x);
    localStorage.setItem("propertyButtons", y);
    if (props.allProperties && props.allProperties[index]?._id) {
      console.log(index, "1234567890", props.allProperties[index]?._id, props.sidebarClassesProperty.length)
      DashboardPropertyToggle(props.allProperties, index, props.setpropertyToggles)
    }
  };
  const toggleChannelCard = (event, index) => {
    let x = [...props.sidebarClassesChannel];
    let y = [...props.channelsButtons];
    for (let i = 0; i < x.length; i++) {
      if (i !== index) {
        y[i] = "fa-plus-circle";
        x[i] = "0";
      }
    }
    y[index] = x[index] === "1" ? "fa-plus-circle" : "fa-minus-circle";
    x[index] = x[index] === "1" ? "0" : "1";
    props.setsidebarClassesChannel(x);
    props.setchannelsButtons(y);
  };
  const checkProperty = (propArray, id) => {
    return propArray.some((el) => {
      return el.PropertyId === id;
    });
  }
  return (
    <Accordion className="left-sidefixed" >
      <Card
        className="leftCard card-sidebar change-margin-top"
      >
        <Card.Body className="card-body2">
          <Accordion activeKey={getActiveKeyProperty()}>
            {props.allProperties.sort((a, b) => a.Name.localeCompare(b.Name)).map(
              (property, propertyindex) => {
                return (
                  <Card
                    key={propertyindex}
                    className="card-sidebar leftcard"
                  >
                    <Card.Header
                      eventKey={propertyindex.toString()}
                    >
                      <Link to="/clouddashboard" style={{ color: "white", textDecoration: 'none' }}
                        onClick={(event) =>
                          togglePropertyCard(event, propertyindex)
                        }
                      >
                        <i
                          className={
                            "cus-pointer fa head circlegreen " +
                            props.propertyButtons[propertyindex]
                          }
                          style={{ color: "white" }}
                        ></i>{" "}
                        <href
                          className={
                            "headcustm-btn color-inherit text-dec-underline"
                          }
                          style={{ color: "white" }}
                        >
                          {property.Name}
                        </href></Link>
                    </Card.Header>
                    <Accordion.Collapse
                      eventKey={propertyindex.toString()}
                    >
                      <Card.Body className="card-body2" >
                        <Accordion
                          activeKey={getActiveKeyChannel()}
                        >
                          {props.allChannels.map(
                            (channel, channelindex) => {
                              if (
                                checkProperty(channel.PropertyType, property._id)
                              ) {
                                return (
                                  <Card
                                    key={channelindex}
                                    className="card-sidebar leftcard"
                                  >
                                    <Card.Header
                                      eventKey={channelindex.toString()}
                                    >
                                      <Link to="/clouddashboard" style={{ color: "white", textDecoration: 'none' }}>
                                        <href
                                          className={
                                            "headcustm-btn color-inherit text-dec-underline"
                                          }
                                          onClick={(event) =>
                                            toggleChannelCard(
                                              event,
                                              channelindex
                                            )
                                          }
                                          style={{ color: "white", marginLeft: "4px" }}
                                        >
                                          {channel.channelName}
                                        </href>
                                      </Link>
                                    </Card.Header>
                                  </Card>
                                );
                              } else {
                                return <div></div>;
                              }
                            }
                          )}
                        </Accordion>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                );

              }
            )}
          </Accordion>
        </Card.Body>

      </Card>
    </Accordion>
  );
};

export default CloudSidebar;



